//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import editor from "vue2-ace-editor";
// eslint-disable-next-line import/no-extraneous-dependencies
import "brace/mode/text";
// eslint-disable-next-line import/no-extraneous-dependencies
import "brace/theme/tomorrow";
import { mapActions } from "vuex";
import { APP_DATE_DOT_FORMAT, APP_DATE_DOT_DMY_FORMAT } from "@/assets/js/appConfig";
import {
    downloadErrorCode,
    copyToClipboard,
    convertAndFormatTimeToLocal
} from "@/assets/js/appFunc";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQMenu from "@/components/Generics/AQMenu/AQMenu.vue";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";
import PIModalErrorInfo from "./components/PIModalErrorInfo.vue";
import PIApiBlockchainModalSummary from "./components/PIApiBlockchainModalSummary.vue";

export default {
    components: {
        PIModalErrorInfo,
        PIApiBlockchainModalSummary,
        editor,
        AQModal,
        AQDialog,
        AQCard,
        AQButton,
        AQMenu
    },
    props: {
        api: {
            type: Object,
            default: () => {}
        },
        instanceName: {
            type: String,
            default: ""
        },
        instanceStatus: {
            type: String,
            default: ""
        },
        instanceID: {
            type: String,
            default: ""
        },
        apiVariable: {
            type: Boolean,
            default: false
        },
        blockchain: {
            type: Boolean,
            default: false
        },
        value: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            APP_DATE_DOT_FORMAT,
            PIApiModal: false,
            readonly: true,
            selectedTab: "",
            showPopupResponse: [],
            componentKey: 0,
            showRemoveConfirmation: false,
            showReqDeleted: false,
            showResDeleted: false,
            messageReq: null,
            messageRes: null,
            apiData: null,
            showModal: false,
            reqDeleted: false,
            respDeleted: false,
            apiProp: this.api

        };
    },
    computed: {
        selectTab: {
            get() {
                return this.apiProp.activityType === "BLOCKCHAIN_EVENT_PLUGIN" ? "response" : this.selectedTab;
            },
            set(v) {
                this.selectedTab = v;
            }
        },
        errorInfoProps() {
            return {
                api: this.apiProp,
                mode: "api"
            };
        },
        displayDeleteMessage() {
            return this.blockchain ? this.$t("admin.processInspector.messageBlockchain", { type: this.selectedTab })
                : this.$t("admin.processInspector.messageApi", { type: this.selectedTab });
        },
        displayTitle() {
            return this.blockchain ? this.$t("admin.processInspector.titleBlockchainModal", { type: this.selectedTab })
                : this.$t("admin.processInspector.titleApiModal");
        },
        optionMenu() {
            return [
                {
                    value: "copy",
                    label: this.$t("admin.processInspector.copy")
                },
                {
                    value: "download",
                    label: this.$t("admin.processInspector.download")
                },
                {
                    value: "delete",
                    label: this.selectedTab === "request" ? this.$t("admin.processInspector.deleteDataRequest")
                        : this.$t("admin.processInspector.deleteDataResponse"),
                    itemDisabled: this.checkStatus()
                }
            ];
        },
        ApiBlockchainModalSummaryProps() {
            return {
                instanceStatus: this.instanceStatus,
                apiVariable: this.apiVariable,
                blockchain: this.blockchain,
                api: this.apiProp,
                instanceName: this.instanceName
            };
        },
        noResponseAvailable() {
            let message = this.$t("admin.processInspector.noMessagesToBeDisplayed");
            if (this.apiProp.response === "_data_deleted") {
                message = this.messageNoAvailable(this.apiProp, "response");
            }
            return message;
        },
        responseApi() {
            return this.apiProp.response
                ? this.apiProp.response
                : this.$t("admin.processInspector.noRespAvailable");
        },
        requestApi() {
            return this.apiProp.request
                ? this.apiProp.request
                : this.$t("admin.processInspector.noReqAvailable");
        },
        noRequestAvailable() {
            let message = this.$t("admin.processInspector.noMessagesToBeDisplayed");
            if (this.apiProp.request === "_data_deleted") {
                message = this.messageNoAvailable(this.apiProp, "request");
            }
            return message;
        }
    },
    watch: {
        showReqDeleted: {
            handler(value) {
                if (value) {
                    this.messageReq = this.messageNoAvailable(this.apiData, "request");
                }
            },
            immediate: true
        },
        showResDeleted: {
            handler(value) {
                if (value) {
                    this.messageRes = this.messageNoAvailable(this.apiData, "response");
                }
            },
            immediate: true
        },
        value: {
            handler(newValue) {
                this.showModal = newValue;
            },
            immediate: true
        }
    },
    created() {
        if (this.apiVariable) {
            this.getApiRequestResponse(this.apiProp.id).then(rsp => {
                if (rsp.data) {
                    const { request, response } = rsp.data;
                    if (request === "_data_deleted") {
                        this.apiData = rsp.data;
                        this.showReqDeleted = true;
                    } else {
                        this.apiProp.request = request;
                    }
                    if (response === "_data_deleted") {
                        this.apiData = rsp.data;
                        this.showResDeleted = true;
                    } else {
                        this.apiProp.response = response;
                    }
                    this.selectedTab = "request";
                }
            });
        } else {
            this.selectedTab = "request";
        }
    },
    methods: {
        ...mapActions("admin", ["deleteRequestResponseApiModal", "deleteRequestResponseBlockchainModal", "getApiRequestResponse"]),
        downloadErrorCode,
        copyToClipboard,
        convertAndFormatTimeToLocal,
        optionSelectedResponse(evt) {
            this.componentKey++;
            if (evt[0].value === "copy") {
                this.copyReqResp(false);
            } else if (evt[0].value === "download") {
                this.downloadErrorCode(this.responseApi, "Api-Response");
            } else if (evt[0].value === "delete") {
                this.showRemoveConfirmation = true;
            }
            this.showPopupResponse = [];
        },
        messageNoAvailable(api, tab) {
            let mess = this.$t("admin.processInspector.dataDeleted");
            const { request, response, deleteEventList } = api;
            if (deleteEventList && deleteEventList.length) {
                if (tab === "request" && request === "_data_deleted") {
                    const req = deleteEventList.find(elem => elem.section === "request");
                    mess = ` ${this.$t("admin.processInspector.dataDeletedBy", { user: req.username })}
                   ${this.convertAndFormatTimeToLocal(req.execDate, APP_DATE_DOT_DMY_FORMAT)} `;
                }
                if (tab === "response" && response === "_data_deleted") {
                    const res = deleteEventList.find(elem => elem.section === "response");
                    mess = ` ${this.$t("admin.processInspector.dataDeletedBy", { user: res.username })}
                   ${this.convertAndFormatTimeToLocal(res.execDate, APP_DATE_DOT_DMY_FORMAT)} `;
                }
            } else if (api.username) {
                mess = ` ${this.$t("admin.processInspector.dataDeletedBy", { user: api.username })}
                   ${this.convertAndFormatTimeToLocal(api.execDate, APP_DATE_DOT_DMY_FORMAT)} `;
            }
            return mess;
        },
        optionSelectedRequest(evt) {
            this.componentKey++;
            if (evt[0].value === "copy") {
                this.copyReqResp(true);
            } else if (evt[0].value === "download") {
                this.downloadErrorCode(this.requestApi, "Api-Request");
            } else if (evt[0].value === "delete") {
                this.showRemoveConfirmation = true;
            }
            this.showPopupResponse = [];
        },
        actionsDlg($event) {
            if ($event === "close") {
                this.$emit("input");
            }
        },
        actionRemoveData(action) {
            if (action) {
                const data = {
                    instanceID: this.instanceID,
                    id: this.apiProp.id,
                    type: this.selectedTab
                };
                const changeData = res => {
                    this.showNotify(this.selectTab);
                    this.apiData = res;
                    if (this.selectTab === "request") {
                        this.reqDeleted = true;
                        this.showReqDeleted = true;
                    } else {
                        this.respDeleted = true;
                        this.showResDeleted = true;
                    }
                };
                if (this.blockchain) {
                    this.deleteRequestResponseBlockchainModal(data).then(res => {
                        changeData(res.data);
                    });
                } else {
                    this.deleteRequestResponseApiModal(data).then(res => {
                        changeData(res.data);
                    });
                }
            } else {
                this.showRemoveConfirmation = false;
            }
        },
        showNotify(param) {
            const notifyMess = this.blockchain ? this.$t("admin.processInspector.blockchainDelete", { type: param })
                : this.$t("admin.processInspector.apiDelete", { type: param });
            this.$toast.showNotify({
                type: "success",
                message: notifyMess,
                timeout: 500
            });
        },
        editorInit(editorInstance) {
            editorInstance.setReadOnly("true");
        },
        copyError() {
            this.copyToClipboard(this.apiProp.error);
        },
        copyReqResp(isRequest) {
            if (isRequest) {
                this.copyToClipboard(this.requestApi);
            } else {
                this.copyToClipboard(this.responseApi);
            }
        },
        copyClipboard() {
            this.copyToClipboard(this.apiProp.traceId);
        },
        checkStatus() {
            let disabledOpt = false;
            if (this.instanceStatus === "RUNNING" || this.instanceStatus === "FAILED") {
                disabledOpt = true;
            }
            return disabledOpt;
        }
    }
};
